import Cookies from "js-cookie";
import helperUtilities from "shared/mixins/helper-utilities";
import helperTemplates from "shared/mixins/helper-templates";

/**
 * @module
 *
 */

const selector = "[data-js-misc-questions]";
const questions = function (el, app) {
    const utilities = helperUtilities(app);

    let acceptingClicks = false;
    const $document = $(document);
    const $el = $(el);

    let $items = $();
    let $radios = $();
    let $qs = $();
    let notifyOnStartup = false;

    const $answered = $el.find(".Ge-Ny-Questions-Outer--answered");
    const $close = $el.find("[data-js-misc-questions-close]");
    const templateHelper = helperTemplates(app);
    const questions = window[$el.attr("data-js-misc-questions-src")];

    const loaded = $.Deferred();

    // el.interface = {
    //     getValue: getValue,
    //     getQuestions: function () {
    //         return questions;
    //     },
    //     loaded: function () {
    //         return loaded;
    //     },
    // };

    const init = function () {
        buildQuestions();

        $items = $el.find("[data-js-misc-questions-outer]");
        $radios = $el.find("[data-js-misc-questions-input]");
        $qs = $el.find("[data-js-misc-questions-question]");

        registerEvents();
        setupTree();

        el.interface = {
            getValue: getValue,
            getQuestions: function () {
                return questions;
            },
        };

        if (notifyOnStartup) {
            //notifyChange();
        }

        loaded.resolve();
    };

    const getValue = function () {
        let result = [];
        $items
            .not(".Ge-Hidden")
            .find("input:checked")
            .each(function (_, el) {
                result.push({
                    question: $(el)
                        .closest("[data-js-misc-questions-q-id]")
                        .attr("data-js-misc-questions-q-id"),
                    answer: $(el).val(),
                    text: $(el).parent().find(".Ge-Ny-Questions-A-Text").text(),
                });
            });

        return result;
    };

    const notifyChange = function () {
        $el.trigger({ type: "change" });
    };

    const notifyReOpen = function () {
        $el.trigger({ type: "reopen" });
    };

    const buildQuestions = function ($insertAfter) {
        let $templatePost = false;
        const $templatePre = templateHelper.get("[data-template-question]");
        // for each question
        questions.forEach(function buildQuestionsLoop(question) {
            $templatePost = $templatePre.clone();
            $templatePost.attr("data-js-misc-questions-q-id", question.id);
            $templatePost
                .find("[data-js-misc-questions-inner]")
                .attr("aria-labelledby", "q-" + question.id);
            $templatePost
                .find("[data-js-misc-questions-question]")
                .text(question.question);
            $templatePost
                .find("[data-js-misc-questions-question]")
                .attr("id", "q-" + question.id);
            if (question.open) {
                $templatePost.addClass("Ge-Ny-Questions-Outer--open");
            }
            // build answers
            $templatePost = buildAnswers(question, $templatePost);
            // paint to page

            if (!$insertAfter) {
                $templatePost.prependTo($el);
            } else {
                $templatePost.insertAfter($insertAfter);
            }
            $insertAfter = $templatePost;
            //$('[data-js-misc-questions-outer]').before($templatePost);
            // get obj of all the radio buttons to attach events to them.
            //$radios = $el.find('[data-js-misc-questions-input]');
        });

        // trigger accordion bootstrap
        // const questionEl = document.querySelector('[data-js-misc-questions-async]');
        // nyQuestions(questionEl, app);
    };

    const buildAnswers = function (question, $templatePost) {
        const $templateInnerPre = templateHelper.get("[data-template-answer]");
        const answersData = question.answers;
        let $templateInnerPost = false;
        let $buffer = [];
        let inputsPost = false;
        // for each answer to a question
        answersData.forEach(function buildAnswersLoop(answer) {
            $templateInnerPost = $templateInnerPre.clone();
            $templateInnerPost
                .find("[data-js-misc-questions-input]")
                .attr("name", question.id);
            $templateInnerPost
                .find("[data-js-misc-questions-input]")
                .val(answer.id);
            $templateInnerPost
                .find("[data-js-misc-questions-answer]")
                .text(answer.answer);
            $templateInnerPost
                .find("[data-js-misc-questions-input]")
                .attr("data-js-misc-questions-goto", answer.gotoQuestion);
            $buffer = $.merge($buffer, $templateInnerPost);
        });

        $templatePost.find("[data-js-misc-questions-answers]").html($buffer);
        return $templatePost;
    };

    const useCookies = function () {
        return !!utilities.getAppName();
    };

    const getCookieName = function (inputName) {
        return utilities.getAppName() + "Q-" + inputName;
    };

    const setupTree = function () {
        $items
            .not(":first-child")
            .attr("aria-hidden", "true")
            .addClass("Ge-Hidden");
        $qs.attr("tabindex", "0");
        $radios.attr("tabindex", "0");

        $.each($radios, function setupTreeEach(index, radio) {
            const $radio = $(radio);
            const inputName = $radio.attr("name");
            const inputValue = $radio.attr("value");

            if (useCookies()) {
                const cookieName = getCookieName(inputName);
                const cookieValue = Cookies.get(cookieName, { path: "/" });
                if (cookieValue === inputValue) {
                    $radio.prop("checked", true);
                    cookieAnswer($radio);
                    notifyOnStartup = true;
                }
            }
        });
        setTimeout(function () {
            $el.addClass("Ge-Ny-Questions--animate");
        }, 500);
        acceptingClicks = true;
        // ARIA
        $el.addClass("Ge-Ny-Questions--ready");
    };

    const registerEvents = function () {
        $radios.on("change", function (ev) {
            answerQuestion(ev, $(this), true);
        });
        $radios.on("questionUpdate", answerQuestion);
        // $radios.on('questionAnswered', answerQuestion); // custom event when we want to trigger the same result as triggering "change", but not set off any other events in other scripts (eg, recommendation updates)
        $radios.on("click", answerClick);
        $document.on("click", "[data-js-misc-questions-close]", closeQuestion);
        $qs.on("click", tabToFirstOption);
        $el.on(
            "click keyup",
            ".Ge-Ny-Questions-Outer--answered:not(.Ge-Ny-Questions-Outer--open)",
            reOpenQuestion,
        );
    };

    const getQuestion = function ($e) {
        return $e.closest("[data-js-misc-questions-outer]");
    };

    const tabToFirstOption = function (ev) {
        ev.preventDefault();
        getQuestion($(this))
            .find("[data-js-misc-questions-input]")
            .first()
            .focus();
    };

    const cookieAnswer = function ($radio, notify) {
        answerQuestion(null, $radio, false);
    };

    const answerQuestion = function (ev, $radio, notify) {
        if (ev) {
            ev.stopPropagation();
        }

        //const $treeInput = $(this);
        const $treeQThis = getQuestion($radio);
        const inputName = $radio.attr("name");
        const gotoQuestion = $radio.attr("data-js-misc-questions-goto");
        const inputValue = $radio.attr("value");
        const $treeOption = $radio.closest("[data-js-misc-questions-option]");

        $treeQThis.attr("data-js-misc-questions-selected-answer", inputValue);

        if ($treeQThis.hasClass("Ge-Hidden")) {
            return;
        }

        const $following = $treeQThis.nextAll("[data-js-misc-questions-outer]");
        $following.addClass("Ge-Hidden");

        let $showQ = $();

        if (gotoQuestion) {
            $showQ = $el.find(
                "[data-js-misc-questions-q-id=" + gotoQuestion + "]",
            );
        }
        // else {
        //     $showQ = $treeQThis.next();
        // }

        if ($showQ.length === 1) {
            $showQ.removeClass("Ge-Hidden").attr("aria-hidden", "false");

            //if (!$showQ.is('.Ge-Ny-Questions-Outer--answered')) {
            $showQ.addClass("Ge-Ny-Questions-Outer--open");
            //}

            $showQ.find("[data-js-misc-questions-question]").focus();
            notify = false;
        }

        // $treeQThis.next('[data-js-misc-questions-outer]').not('.Ge-Ny-Questions-Outer--answered');
        // reset old classes
        $treeQThis.removeClass("Ge-Ny-Questions-Outer--open");
        $treeOption
            .siblings("[data-js-misc-questions-option]")
            .removeClass("Ge-Ny-Questions-A-Option--checked");
        // add new classes
        $treeOption.addClass("Ge-Ny-Questions-A-Option--checked");
        $treeQThis.addClass("Ge-Ny-Questions-Outer--answered");
        // if ($treeQNext.length) {
        //     $treeQNext.addClass('Ge-Ny-Questions-Outer--open');
        // }
        // ARIA
        $treeQThis
            .find("[data-js-misc-questions-option]")
            .attr("aria-hidden", "true");
        $treeQThis
            .find("[data-js-misc-questions-input]")
            .attr("aria-hidden", "true");

        // $treeQNext.attr('aria-hidden', 'false');
        // $treeQNext.find('[data-js-misc-questions-question]').focus();
        // cookie

        if (useCookies()) {
            const cookieName = getCookieName(inputName);
            Cookies.set(cookieName, inputValue, { expires: app.cookieLong });
        }

        // accept clicks again
        acceptingClicks = false;
        setTimeout(function () {
            acceptingClicks = true;
        }, 300);

        // ga
        if (ev && (ev.type === "change" || ev.type === "questionAnswered")) {
            const questionText = $radio
                .closest("[data-js-misc-questions-inner]")
                .find("[data-js-misc-questions-question]")
                .text();
            const answerText = $radio
                .next("[data-js-misc-questions-answer]")
                .text();
            app.trigger(
                "beacon",
                "hjälp-mig-question-answer," + questionText + ": " + answerText,
            );
        }

        if (notify) {
            notifyChange();
        }
    };

    const answerClick = function (ev) {
        ev.stopPropagation();
        const $radio = $(this);
        const currentAnswer = getQuestion($radio).attr(
            "data-js-misc-questions-selected-answer",
        );
        if (currentAnswer === $radio.val()) {
            answerQuestion(ev, $radio, true);
        }
    };

    const closeQuestion = function (ev) {
        ev.stopPropagation();
        const $question = getQuestion($(this)); // $(this).closest('[data-js-misc-questions-outer]');
        const $input = $question.find("[data-js-misc-questions-input]:checked");

        answerQuestion(ev, $input, true);
        //$input.trigger('questionUpdate', ev );
    };

    const reOpenQuestion = function (ev) {
        if (!acceptingClicks) {
            return;
        }

        ev.preventDefault();
        const $el = $(this);
        $items.removeClass("Ge-Ny-Questions-Outer--open");
        $el.addClass("Ge-Ny-Questions-Outer--open");
        // ARIA
        $el.find("[data-js-misc-questions-option]").attr(
            "aria-hidden",
            "false",
        );
        $el.find("[data-js-misc-questions-input]").attr("aria-hidden", "false");

        // ga
        //const questionText = $el.find('[data-js-misc-questions-question]').text();
        //app.trigger('beacon', 'hjälp-mig-question-reopen,' + questionText);
        notifyReOpen();
    };

    return {
        init: init(),
    };
};

questions.selector = selector;

export default questions;
